"use strict";
/**
 * Created by Ning Jiang on 12/14/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourcesGroupName = void 0;
var ResourcesGroupName;
(function (ResourcesGroupName) {
    ResourcesGroupName["INTRO"] = "intro";
    ResourcesGroupName["MAIN"] = "main";
    ResourcesGroupName["FREESPIN"] = "freespin";
    ResourcesGroupName["BONUS"] = "bonus";
})(ResourcesGroupName = exports.ResourcesGroupName || (exports.ResourcesGroupName = {}));
//# sourceMappingURL=ResourcesGroupName.js.map